export default __webpack_public_path__ + "static/media/send.e547a484.svg";